import React, { useEffect, useMemo, useState } from 'react'
import { observer, Provider } from 'mobx-react'
import { ConfigProvider, Layout, Dropdown, Menu, Divider, Select } from 'antd'
import { Link, HashRouter } from 'react-router-dom'
import * as Icon from '@ant-design/icons'
import 'moment/locale/zh-cn'

import logo from 'src/static/src_assets_main_logo.svg'
import managerUser from 'src/static/icons/manager_user.svg'

import AppStore from './store'
import Pages from './Pages'
import lang, { locale } from './lang'
import './app.less'

const isComplete =
  process.env.REACT_APP_IS_COMPLETE === 'true' ||
  (process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_IS_DEBUG === 'false')
const fieds = lang.Common
// 独立部署环境的帮助文档 匹配origin的sdwan-pro 或 sdwan 替换为home
const helpDocumentUrl =
  window.location.origin.replace(/sdwan\-pro|sdwan/, 'home') +
  '/#/doc/content/sdwan'
// const store = new AppStore()

function App() {
  const [store] = useState(new AppStore())

  const {
    dictInfo,
    onLangItemClick,
    lang,
    defaultMenuKey,
    menu,
    getPathname,
    openKey,
    setOpenkey,
    onSignOut,
    selectUser
  } = store

  const hasAuth = !!window.localStorage.getItem('sdwan-hasAuth') // 是否已开通服务

  // 语言下拉菜单
  const langDropMenu = useMemo(
    () => (
      <Menu onClick={onLangItemClick} selectedKeys={[lang]}>
        <Menu.Item key="zh_CN">
          <a>中文</a>
        </Menu.Item>

        <Menu.Item key="en_US">
          <a>English</a>
        </Menu.Item>
      </Menu>
    ),
    [onLangItemClick, lang]
  )

  // 用户下拉菜单
  const userDropMenu = useMemo(() => {
    const authId = window.localStorage.getItem('sdwan-authId')
    const authUsers =
      JSON.parse(window.localStorage.getItem('sdwan-authUsers')) || []
    return (
      <Menu>
        <Menu.Item>
          <Select
            style={{ minWidth: 150 }}
            options={authUsers?.map((item: any) => ({
              ...item,
              label:
                item?.auth?.mode === 20
                  ? `【${fieds.Channel}】${item?.label}（${item?.name}）`
                  : `${item?.label}（${item?.name}）`, // mode=20加渠道用户标记
              value: item?.aliasId
            }))}
            onClick={(e) => e.stopPropagation()}
            defaultValue={authId}
            onChange={selectUser}
          />
        </Menu.Item>

        <Menu.Item>
          <a onClick={onSignOut}>{fieds.Exit}</a>
        </Menu.Item>
      </Menu>
    )
  }, [onSignOut])

  useEffect(() => {
    store.getMenu()
    // 页面初始化获取一次全局字典
    store.getInfo()
  }, [])

  // 获取用户名
  const getUserName = () => {
    if (window.localStorage.getItem('sdwan-username')) {
      const loginAuthId = window.localStorage.getItem('sdwan-loginAuthId')
      const authId = window.localStorage.getItem('sdwan-authId')
      // 判断当前authId是否不为登录用户loginAuthId
      return (
        <a>
          {loginAuthId !== authId ? (
            <img src={managerUser} style={{ width: 20 }} />
          ) : null}
          {window.localStorage.getItem('sdwan-username') || fieds.UserName}
          {React.createElement(Icon.DownOutlined)}
        </a>
      )
    } else {
      return (
        <a>
          {fieds.UserName}
          {React.createElement(Icon.DownOutlined)}
        </a>
      )
    }
  }

  return (
    <HashRouter>
      <React.StrictMode>
        <ConfigProvider locale={locale[lang]}>
          <Provider appStore={store}>
            <Layout className="sdwan-layout">
              {isComplete && (
                <Layout.Header>
                  <div className="logo">
                    <img src={logo} />
                  </div>

                  <nav>
                    <div className="nav-left"></div>

                    <div className="nav-right">
                      {/* <a href={helpDocumentUrl} target="_blank">
                        {fieds.Document}
                      </a>

                      <Divider type="vertical" /> */}

                      <Dropdown
                        overlay={langDropMenu}
                        placement="bottomRight"
                        arrow
                      >
                        <a>{lang === 'zh_CN' ? '中文' : 'English'}</a>
                      </Dropdown>

                      <Divider type="vertical" />

                      <Dropdown
                        overlay={userDropMenu}
                        placement="bottomRight"
                        arrow
                        className="username"
                      >
                        {getUserName()}
                      </Dropdown>
                    </div>
                  </nav>
                </Layout.Header>
              )}

              <Layout>
                {isComplete && (
                  <Layout.Sider>
                    {/* <div className="menu-title">SD-WAN</div> */}

                    {hasAuth && (
                      <Menu
                        mode="inline"
                        selectedKeys={[defaultMenuKey]}
                        openKeys={openKey}
                        onOpenChange={setOpenkey}
                      >
                        {menu.map((item) =>
                          item.children ? (
                            <Menu.SubMenu
                              key={item.key}
                              title={item.title}
                              icon={
                                typeof item.icon === 'string'
                                  ? React.createElement(
                                      (Icon as any)[item.icon]
                                    )
                                  : item.icon
                              }
                            >
                              {item.children.map((subItem) => (
                                <Menu.Item key={subItem.key}>
                                  <Link to={subItem.to}>{subItem.title}</Link>
                                </Menu.Item>
                              ))}
                            </Menu.SubMenu>
                          ) : (
                            <Menu.Item
                              key={item.key}
                              icon={
                                typeof item.icon === 'string'
                                  ? React.createElement(
                                      (Icon as any)[item.icon]
                                    )
                                  : item.icon
                              }
                            >
                              <Link to={item.to}>{item.title}</Link>
                            </Menu.Item>
                          )
                        )}
                      </Menu>
                    )}
                  </Layout.Sider>
                )}

                <Layout.Content className="simple-scroll-bar">
                  {dictInfo._myDictInfo && (
                    <Pages getPathname={getPathname} hasAuth={hasAuth} />
                  )}
                </Layout.Content>
              </Layout>
            </Layout>
          </Provider>
        </ConfigProvider>
      </React.StrictMode>
    </HashRouter>
  )
}

export default observer(App)
